export const GET_CUSTOMER_WATCHLIST = "GET_CUSTOMER_WATCHLIST";